import SlashCircle from "@/assets/icons/slash-circle-01.svg?url";
import { i18n } from "@/plugin/vue-i18n";
const { t } = i18n.global;

export const PRODUCT_TYPE = {
  MAIN_PRODUCT: {
    label: t("common.payment.product.mainProduct"),
    value: "main",
  },
  BUMP_PRODUCT: {
    label: t("common.payment.bumProduct.bumpProduct"),
    value: "bump",
  },
};

export const PRODUCT_TYPE_VALUES = Object.values(PRODUCT_TYPE).map((type) => ({
  label: type.label,
  value: type.value,
}));

export const ORDER_BUMP_STYLES = [
  { key: "modern", name: t("common.payment.bumProduct.modern") },
  { key: "classic", name: t("common.payment.bumProduct.classic") },
];

export const BUMP_TEMPLATES = [
  { label: t("common.payment.bumProduct.templateOne"), value: "templateOne" },
  { label: t("common.payment.bumProduct.templateTwo"), value: "templateTwo" },
  { label: t("common.payment.bumProduct.templateThree"), value: "templateThree" },
];

export const BUMP_ICONS = [
  {
    label: t("common.payment.bumProduct.animationIcon.none"),
    value: "none",
    imageUrl: SlashCircle,
  },
  {
    label: t("common.payment.bumProduct.animationIcon.arrow"),
    value: "arrow",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/arrow.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.fire"),
    value: "fire",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/fire.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.plus"),
    value: "plus",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/plusSign.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.giftBox"),
    value: "giftBox",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/wrappedGift.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.timer"),
    value: "timer",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/alarmClock.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.cracker"),
    value: "cracker",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/collision.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.snack"),
    value: "snack",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/bellhopbell.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.partyBalloon"),
    value: "partyBalloon",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/balloon.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.flash"),
    value: "flash",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/electricity.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.money"),
    value: "money",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/moneyWithWings.gif",
  },
  {
    label: t("common.payment.bumProduct.animationIcon.spaceShuttle"),
    value: "spaceShuttle",
    imageUrl: "https://stcdn.leadconnectorhq.com/forms/gifs/rocket.gif",
  },
];

export const RECURRING_DONATION_FREQUENCIES = [
  { label: t("common.recurringFrequency.once"), value: "once" },
  { label: t("common.recurringFrequency.daily"), value: "day" },
  { label: t("common.recurringFrequency.weekly"), value: "week" },
  { label: t("common.recurringFrequency.monthly"), value: "month" },
  { label: t("common.recurringFrequency.yearly"), value: "year" },
];
